<template>
  <CDialog v-bind="{ show }" no-header>
    <div class="p-5">
      <CRoundedIcon
        class="!text-4.5xl"
        color="!text-red bg-red-100"
        icon="icon-filled-warning"
      />
      <p
        class="text-center mt-5 text-xl leading-130 font-semibold text-dark-100"
      >
        {{ $t("robot_create_warning_title") }}
      </p>
      <p
        class="text-base leading-130 font-normal text-gray-700 text-center mt-2 mx-auto"
        v-html="$t('robot_create_warning_content')"
      ></p>
      <div class="mt-7 flex-y-center gap-4">
        <CButton
          variant="info"
          class="w-full"
          @click="handleCloseModal"
          :text="$t('cancel')"
          :disabled="loading"
        />
        <CButton
          class="w-full"
          :text="$t('confirm')"
          @click="handleCreateBot"
          :loading="loading"
          :disabled="loading"
        />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CRoundedIcon from "@/components/Common/CRoundedIcon.vue";
import CButton from "@/components/Common/CButton.vue";

interface Props {
  show: boolean;
  loading: boolean;
}
defineProps<Props>();

const emit = defineEmits<{
  (e: "createBot"): void;
  (e: "close"): void;
}>();

const handleCloseModal = () => {
  emit("close");
};
const handleCreateBot = () => {
  emit("createBot");
};
</script>
